import { createFileRoute } from "@tanstack/react-router";

import { CodPage } from "../../../../features/shipping/cod-page";

export const Route = createFileRoute("/_app/payments/cod/")({ component: CodPage });
